import { fetchSchool } from "app/school/ducks/school";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createFetchErrorMessage } from "utils/api/ApiClient";

export const useSchoolChecker = ()=>{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const school = useSelector(state => state.school);

    useEffect(() => {
        if(school.name===null)return;
        toast.info(`${school.cityName} - ${school.name}에 접속하셨습니다.`)
    }, [school]);
    
    useEffect(() => {
        const urlSchoolCode = location.pathname.split('/')[1];
        if( school.code===urlSchoolCode )return;
        window.schoolCode = urlSchoolCode;
        
        const promise = dispatch(fetchSchool(urlSchoolCode));
        promise.catch(err=>{
            const errorData = createFetchErrorMessage(err);
            toast.error(errorData.message);
            navigate('/');
        });
        
    }, [dispatch, location, navigate, school]);
}